module.exports = __webpack_public_path__ + "img/1460.88482b5d.gif";